<script>
export default {
  props: {
    input: {
      type: String,
      default: () => ''
    },
    field: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    inputData: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      // data: '',
      other: '',
      otherIsSelect: false,
      fullName: '',
      sex: '先生'
    }
  },
  computed: {
    data() {
      return `${this.fullName} ${this.sex}`;
    }
  },
  watch: {
    inputData: {
      handler(v, ov) {
        this.setFromData()
      },
      deep: true
    },
    data: {
      handler(v, ov) {
        this.$emit('update:inputData', v)
      },
      deep: true
    },
  },
  mounted() {
    this.setFromData();
  },
  methods: {
    setFromData() {
      this.$nextTick(() => {
        // this.data = this.inputData;
      });
    }
  },
  inject: ['$validator'],
}

</script>
<template>
  <div>
    <b-field
      :label="`${field.title}`"
      class="is-style-extrafield-name"
      :message="errors.first(name)"
      :type="{ 'is-danger': errors.has(name) }"
      :class="{ [$style['isRequired']]: field.required }"
    >
      <b-field
      >
        <b-input
          v-model.trim="fullName"
          v-validate="{ required: Boolean(field.required) }"
          :data-vv-as="'姓名'"
          :name="`${field.id}_${field.alias}_fullName`"
          placeholder="ex: 余春嬌"
          expanded
        ></b-input>
        <b-select
          v-model="sex"
          v-validate="'required'"
          class="has-radius-danger"
          :data-vv-as="$t('global.GENDER'/* 性別 */)"
          :placeholder="$t('global.GENDER'/* 性別 */)"
          :name="`${field.id}_${field.alias}_sex`"
        >
          <option value="小姐">小姐</option>
          <option value="先生">先生</option>
        </b-select>
      </b-field>
    </b-field>
  </div>
</template>
<style lang="scss" module>
  .isRequired {
    :global(.label::after) {
      margin-left: 4px;
      color: $color-danger;
      content: '*';
    }
  }
</style>
